

<template>
	<section class="clearfix">
		<compWrapper title="商品品类" theme="primary">
			<componentNode class="margin-left-15 margin-top-15" @on-data="getNodeData"/>
		</compWrapper>
		<vLoading size="large" transfer :loading="loading"></vLoading>
	</section>
</template>

<script>
import componentNode from './node';
import { mapGetters } from 'vuex';
export default {
	components: {
		compWrapper: () => import("@components/templates/wrapper"),
		compFormQuery: () => import("@components/templates/formquery"),
		componentNode,
	},
	data() {
		return {
			isSystem: false,
			loading: false,
		};
	},
	computed: {
		getBase(){
            return[
                {
                    label: '英文名称',
                    key: 'name',
                    tag: 'vInput',
                    span:24,
                },{
                    label: '中文名称',
                    key: 'type',
                    tag: 'vInput',
                    span:24,
                }, {
                    label: '品类代码',
                    key: 'name',
                    tag: 'vInput',
                    span:24,
                },
            ]
        },
	},
	created() {

	},

	methods: {
		cancel() {
            this.$emit('on-close')
		},
		getNodeData(data = {}, edittype) {
            this.$emit('on-chosedata',data)
            this.cancel()

		},
		
		async updateMenu() {
            
		},
	},
};
</script>
